import { IAmendment } from '../../contracts/amendment.contract';

const getDateString = (amendmentItem: IAmendment[]): string => {
    const vesselDateModifier = amendmentItem[0].AgeModifier === 'before' ? 'before' : 'on or after';

    let gtString: string = amendmentItem[0].GrossTonnage.Value
        ? amendmentItem[0].GrossTonnage && amendmentItem[0].GrossTonnage.LowerBound
            ? `GT ${amendmentItem[0].GrossTonnage.LowerBound.InclusiveExclusive == 'INCLUSIVE' ? '>=' : '>'} ${amendmentItem[0].GrossTonnage.LowerBound.Value} and a `
            : ''
        : '';

    if (amendmentItem[0].GrossTonnage.UpperBound.Value) {
        const upperBoundString: string = `${amendmentItem[0].GrossTonnage.UpperBound.Value} ${amendmentItem[0].GrossTonnage.UpperBound.InclusiveExclusive == 'INCLUSIVE' ? '>=' : '>'}  `;
        gtString = upperBoundString + gtString;
    }

    const complianceDateTypeMap: Record<string, string> = {
        CONTRACT: 'contract',
        DELIVERY: 'delivery',
        KEEL_LAY: 'keel lay'
    };

    const vesselDateType = Array.from(new Set(amendmentItem.map((item) => complianceDateTypeMap[item.ComplianceDateType]))).sort((a, b) => a.localeCompare(b));

    const vesselDateModifiers = amendmentItem.map((item) => (item.AgeModifier === 'before' ? 'before' : 'on or after'));

    if (vesselDateType.length === 1) {
        return `${gtString}${vesselDateType[0]} date ${vesselDateModifiers[0]} ${amendmentItem[0].ShipAgeDate}`;
    }

    if (vesselDateType.length === 2 && amendmentItem[1]) {
        return `${gtString} ${vesselDateType[0]} date ${vesselDateModifiers[0]} ${amendmentItem[0].ShipAgeDate} or ${vesselDateType[1]} date ${vesselDateModifiers[1]} ${amendmentItem[1].ShipAgeDate}`;
    }

    if (vesselDateType.length === 3) {
        return `${gtString} ${vesselDateType[0]} date ${vesselDateModifiers[0]} ${amendmentItem[0].ShipAgeDate}, ${vesselDateType[1]} date ${vesselDateModifiers[1]} ${amendmentItem[1].ShipAgeDate}, or ${vesselDateType[2]} date  ${vesselDateModifiers[2]} ${amendmentItem[2].ShipAgeDate}`;
    }

    return '';
};

export default getDateString;
